var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29 10.38L5.17 6.49999L1.29 2.61999C1.19742 2.52741 1.12398 2.4175 1.07387 2.29653C1.02377 2.17557 0.997978 2.04592 0.997978 1.91499C0.997978 1.78406 1.02377 1.65441 1.07387 1.53345C1.12398 1.41248 1.19742 1.30257 1.29 1.20999C1.38258 1.11741 1.49249 1.04397 1.61346 0.993863C1.73442 0.943758 1.86407 0.917969 1.995 0.917969C2.12593 0.917969 2.25558 0.943758 2.37654 0.993863C2.49751 1.04397 2.60742 1.11741 2.7 1.20999L7.29 5.79999C7.68 6.18999 7.68 6.81999 7.29 7.20999L2.7 11.8C2.60749 11.8927 2.4976 11.9662 2.37662 12.0164C2.25565 12.0666 2.12597 12.0924 1.995 12.0924C1.86403 12.0924 1.73435 12.0666 1.61337 12.0164C1.4924 11.9662 1.38251 11.8927 1.29 11.8C0.909999 11.41 0.899999 10.77 1.29 10.38Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.90a34de4c5c5fd2a8254bb8218750d93.svg";
export { ForwardRef as ReactComponent };